import { render, staticRenderFns } from "./HospitalsEditPopup.vue?vue&type=template&id=40b0d996&"
import script from "./HospitalsEditPopup.vue?vue&type=script&lang=js&"
export * from "./HospitalsEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports